import React, { Component } from 'react';
import BackBtn from './BackBtn';
import {doubleNumber, groupByKey, setComoAfterThirdSymbol, trans} from '../../../helpers';
import Select from 'react-select';
import DatePicker from 'react-datepicker';
import ApiManager from '../../../apiManager';
import Loading from '../../Fragments/Loading';
import Circle from "../../Fragments/Circle";
import FormMiddlewareError from '../../Fragments/FormMiddlewareError';
import Modal from '../../Fragments/Modal';
import ErrorModal from '../../Fragments/ErrorModal';
import Tab from '../../Fragments/Tab';
import { localStorageGetItem } from '../../../storage';

class B2bHistory extends Component {

    constructor( props ){
        super( props );

        this.startDate = new Date();

        this.state = {
            selectedOption: this.options()[0],
            startDate: new Date( this.startDate.setDate(this.startDate.getDate() - 1) ),
            endDate: new Date(),
            filters: '',
            filtersGroup: '',
            onlyPaid: false,
            expenses: '',
            topups: '',
            buttonDisabled: false,
            showModal: false,
            email: ( this.props.profileData !== '' && this.props.profileData.status === 'OK' ? this.props.profileData.data.email : '' ),
            fileType: 'pdf',
            modalButtonDisabled: false,
            modalResponseData: '',
            showSuccessModal: false,
            allowedScrollAddNumber: 10,
            allowedScrollNumber: 0,
            allowedTopupsScrollNumber: 0,
            allowedBonusScrollNumber: 0,
            allowedBonusStockPointsScrollNumber: 0,
            showErrorModal: false,
            redemptionHistory: '',
            balanceHistory: ''
        };

        // Component props
        this.componentIsMounted = true;

        // Bind own methods
        this.handleSelectChange = this.handleSelectChange.bind( this );
        this.filterSuccess = this.filterSuccess.bind( this );
        this.getDetalizationExpensesSuccess = this.getDetalizationExpensesSuccess.bind(this);
        this.getDetalizationTopupsSuccess = this.getDetalizationTopupsSuccess.bind(this);
        this.sendEmailExpensesDataSuccess = this.sendEmailExpensesDataSuccess.bind(this);
        this.redemptionHistorySuccess = this.redemptionHistorySuccess.bind(this);
        this.balanceHistorySuccess = this.balanceHistorySuccess.bind(this);
        this.errorCallBack = this.errorCallBack.bind(this);

    }

    componentWillUnmount(){

        this.componentIsMounted = false;

    }

    initAsyncCalls(){

        let ctn = '';

        if ( this.props.ctn.status === 'OK' && this.props.ctn.data.hasOwnProperty('info') ) {
            ctn = this.props.ctn.data.subscriber.toString().replace(/^374/, '');
        }

        // Get detalization filters
        ApiManager.getRequest({
            jwt: this.props.getDecryptedToken(),
            ctn
        }, '/b2b' + this.props.curator + '/detalization/config').then(this.filterSuccess, this.errorCallBack);

    }

    componentDidMount(){

        this.initAsyncCalls();

    }

    filterSuccess( resolve ){

        if ( !this.componentIsMounted ) {
            return false;
        }

        // @test
        // resolve.data = { "status": "OK", "data": { "filters": [ { "label": "Մուտքային զանգ", "value": "INCALL", "color": "#4e789a" }, { "label": "Ինտերնետ", "value": "INTERNET", "color": "#a35ca2" }, { "label": "Ելքային զանգ", "value": "OUTCALL", "color": "#288960" }, { "label": "Ռոումինգ", "value": "ROAMING", "color": "#0da6bd" }, { "label": "SMS/MMS", "value": "MESSAGE", "color": "#707982" }, { "label": "Այլ", "value": "OTHER", "color": "#694A5F" } ], "contact_email": "", "min_from_date": "2018-12-20" } };

        let filtersGroup = {};

        if ( resolve.data.status === 'OK' ) {
            resolve.data.data.filters.map(( item ) => {
                filtersGroup[item.value] = true;
                return true;
            });
        }

        this.setState({
            filters: resolve.data,
            filtersGroup: filtersGroup
        });

    }

    errorCallBack( reject ){
        this.setState({ showErrorModal: true });
    }

    options(){

        return [
            { value: 1,        label: trans( this.props.b2bTrans, 'b2b.history.filter.select_option_text1' ) },
            { value: 6,        label: trans( this.props.b2bTrans, 'b2b.history.filter.select_option_text2' ) },
            { value: 13,       label: trans( this.props.b2bTrans, 'b2b.history.filter.select_option_text3' ) },
            { value: 'custom', label: trans( this.props.b2bTrans, 'b2b.history.filter.select_option_other' ) }
        ];

    }

    handleSelectChange( newState ){

        this.setState({
            selectedOption: newState
        });

    }

    datepickerChangeHandler(){

        const days = Math.floor( ( this.state.endDate - this.state.startDate ) / 1000 / 60 / 60 / 24 );

        if ( days > 13 ) {
            this.setState({
                showModal: true
            });
        }

    }

    checkBySeconds( d ){

        return Math.floor( d.getTime() / 1000 );

    }

    datepickers(){

        if ( !this.state.selectedOption || ( this.state.selectedOption && this.state.selectedOption.value !== 'custom' ) ) {
            return '';
        }

        return (
            <div className="history-form__pickers">

                <div className="history-form__pickers-item ver-top-box pr sprite-a">
                    <DatePicker
                        selected={this.state.startDate}
                        dateFormat="dd-MM-yyyy"
                        onChange={( date ) => {

                            let startDate = '',
                                endDate = this.state.endDate;

                            if ( date !== null ) {
                                const newDate = new Date(date);
                                startDate = date;

                                if ( endDate ) {
                                    endDate = ( this.checkBySeconds( date ) > this.checkBySeconds( this.state.endDate ) ) ? new Date( newDate.setDate(newDate.getDate()) ) : this.state.endDate;
                                }

                            }

                            this.setState({
                                startDate,
                                endDate
                            }, this.datepickerChangeHandler);

                        }}
                    />
                </div>
                <div className="history-form__pickers-item ver-top-box pr sprite-a">
                    <DatePicker
                        selected={this.state.endDate}
                        dateFormat="dd-MM-yyyy"
                        onChange={( date ) => {

                            let startDate = this.state.startDate,
                                endDate = '';

                            if ( date !== null ) {
                                const newDate = new Date(date);
                                endDate = date;

                                if ( startDate ) {
                                    startDate = ( this.checkBySeconds( date ) < this.checkBySeconds( this.state.startDate ) ) ? new Date( newDate.setDate(newDate.getDate()) ) : this.state.startDate;;
                                }

                            }

                            this.setState({
                                startDate,
                                endDate
                            }, this.datepickerChangeHandler);

                        }}
                    />
                </div>

            </div>
        );

    }

    filterSection(){

        return (

            <section className="main-wrapper__services main-wrapper__services--with-space">

                <div className="main-wrapper__services-title-box pr">
                    <h2 className="main-wrapper__sub-title main-wrapper__sub-title--filter monserrat-medium tl pr sprite-b trans-background">{trans( this.props.b2bTrans, 'b2b.history.filter.title' )}</h2>
                </div>

                <form className="history-form" method="post" action="#" onSubmit={( event ) => this.getFilteredData( event )}>

                    <div className="history-form__flex">
                        <div className="history-form__item">

                            <div className="history-form__label-box">
                                <label className="history-form__label fs11" htmlFor="select">{trans( this.props.b2bTrans, 'b2b.history.filter.select_label' )}</label>
                            </div>

                            <div className="history-form__select-box">
                                <Select
                                    options={this.options()}
                                    value={this.state.selectedOption}
                                    onChange={this.handleSelectChange}
                                    placeholder={trans( this.props.b2bTrans, 'b2b.history.filter.select_default_label' )}
                                    noOptionsMessage={() => trans( this.props.b2bTrans, 'b2b.history.filter.select_no_options_message' )}
                                />
                            </div>

                            {this.datepickers()}

                        </div>

                        <div className="history-form__item">

                            <div className="history-form__label-box">
                                <label className="history-form__label fs11" htmlFor="tag">{trans( this.props.b2bTrans, 'b2b.history.filter.tag_label' )}</label>
                            </div>
                            {this.drawFilters()}

                        </div>

                        <div className="history-form__item history-form__item--top-space">
                            <input
                                className="history-form__switcher-checkbox dn"
                                name="only-paid"
                                id="only-paid"
                                type="checkbox"
                                checked={this.state.onlyPaid}
                                onChange={() => this.setState({ onlyPaid: !this.state.onlyPaid })}
                            />
                            <label
                                className="history-form__switcher btn btn--yellow no-wrap fs14 full-width sprite-b pr ver-top-box select-none"
                                htmlFor="only-paid"
                            >{trans( this.props.b2bTrans, 'b2b.history.filter.button_text1' )}</label>
                        </div>

                        <div className="history-form__item history-form__item--top-space">
                            <button
                                className={`btn btn--white no-wrap fs17 full-width${this.state.buttonDisabled ? ' btn--loading' : ''}`}
                                type="submit"
                                disabled={this.state.buttonDisabled}
                            >{trans( this.props.b2bTrans, 'b2b.history.filter.button_text2' )}</button>
                        </div>

                    </div>

                </form>

            </section>

        );

    }

    drawFilters(){

        let filters = <Loading withBox={true} />;

        if ( this.state.filters !== '' && this.state.filters.status === 'OK' ) {

            filters = this.state.filters.data.filters.map(( item, index ) => {

                return (
                    <div className="ver-top-box" key={index}>
                        <input
                            className="history-form__checkbox dn"
                            name={`tag-${index}`}
                            id={`tag-${index}`}
                            type="checkbox"
                            checked={this.state.filtersGroup[item.value]}
                            onChange={() => {

                                let newState = this.state.filtersGroup;
                                newState[item.value] = !newState[item.value];
                                this.setState({ filtersGroup: newState });

                            }}
                        />
                        <label
                            className="history-form__tag ver-top-box fs14 pr"
                            htmlFor={`tag-${index}`}
                            style={{
                                backgroundColor: item.color,
                                borderColor: item.color
                            }}
                        >
                            <span className="history-form__tag-circle db center-center" style={{ backgroundColor: item.color }}> </span>
                            {item.label}
                        </label>
                    </div>
                );

            });

        }

        if ( this.state.filters !== '' && ( this.state.filters.status === 'ERROR' || this.state.filters.status === 'NOT_FOUND' ) ) {
            filters = <p className="error-message error-message--without-lr-padding">{this.state.filters.message}</p>;
        }

        return (
            <div className="history-form__tag-list select-none">{filters}</div>
        );

    }

    getDetalizationExpensesSuccess( resolve ){

        // @test
        // resolve.data = { "status": "OK", "data": { "records": [ { "type": "OTHER", "label": "Վճար", "group_type": "OTHER", "group_label": "Այլ", "is_group": false, "color": "#694A5F", "date": "04.12.2019", "time": "11:50", "price": 0, "currency": "֏", "number": "", "traffic": "200ՄԲ" }, { "type": "OTHER", "label": "Վճար", "group_type": "OTHER", "group_label": "Այլ", "is_group": false, "color": "#694A5F", "date": "02.12.2019", "time": "18:43", "price": 0, "currency": "֏", "number": "", "traffic": "10ր." }, { "type": "OTHER", "label": "Վճար", "group_type": "OTHER", "group_label": "Այլ", "is_group": false, "color": "#694A5F", "date": "02.12.2019", "time": "18:43", "price": 0, "currency": "֏", "number": "", "traffic": "1024ՄԲ" }, { "type": "OTHER", "label": "Վճար", "group_type": "OTHER", "group_label": "Այլ", "is_group": false, "color": "#694A5F", "date": "02.12.2019", "time": "16:57", "price": 0, "currency": "֏", "number": "", "traffic": "200ՄԲ" }, { "type": "OTHER", "label": "Վճար", "group_type": "OTHER", "group_label": "Այլ", "is_group": false, "color": "#694A5F", "date": "02.12.2019", "time": "16:56", "price": 0, "currency": "֏", "number": "", "traffic": "20ր." }, { "type": "OTHER", "label": "Վճար", "group_type": "OTHER", "group_label": "Այլ", "is_group": false, "color": "#694A5F", "date": "02.12.2019", "time": "11:14", "price": 0, "currency": "֏", "number": "", "traffic": "200ՄԲ" }, { "type": "OTHER", "label": "Վճար", "group_type": "OTHER", "group_label": "Այլ", "is_group": false, "color": "#694A5F", "date": "29.11.2019", "time": "18:34", "price": 0, "currency": "֏", "number": "", "traffic": "200ՄԲ" }, { "type": "OTHER", "label": "Վճար", "group_type": "OTHER", "group_label": "Այլ", "is_group": false, "color": "#694A5F", "date": "25.11.2019", "time": "11:16", "price": 0, "currency": "֏", "number": "", "traffic": "200ՄԲ" }, { "type": "OTHER", "label": "Վճար", "group_type": "OTHER", "group_label": "Այլ", "is_group": false, "color": "#694A5F", "date": "25.11.2019", "time": "11:14", "price": 0, "currency": "֏", "number": "", "traffic": "200ՄԲ" }, { "type": "OTHER", "label": "Վճար", "group_type": "OTHER", "group_label": "Այլ", "is_group": false, "color": "#694A5F", "date": "25.11.2019", "time": "11:14", "price": 0, "currency": "֏", "number": "", "traffic": "200ՄԲ" }, { "type": "OTHER", "label": "Վճար", "group_type": "OTHER", "group_label": "Այլ", "is_group": false, "color": "#694A5F", "date": "25.11.2019", "time": "11:12", "price": 0, "currency": "֏", "number": "", "traffic": "200ՄԲ" }, { "type": "OTHER", "label": "Վճար", "group_type": "OTHER", "group_label": "Այլ", "is_group": false, "color": "#694A5F", "date": "25.11.2019", "time": "11:11", "price": 0, "currency": "֏", "number": "", "traffic": "200ՄԲ" }, { "type": "OTHER", "label": "Վճար", "group_type": "OTHER", "group_label": "Այլ", "is_group": false, "color": "#694A5F", "date": "25.11.2019", "time": "11:09", "price": 0, "currency": "֏", "number": "", "traffic": "4ԳԲ" }, { "type": "OTHER", "label": "Վճար", "group_type": "OTHER", "group_label": "Այլ", "is_group": false, "color": "#694A5F", "date": "25.11.2019", "time": "11:08", "price": 0, "currency": "֏", "number": "", "traffic": "200ՄԲ" }, { "type": "OTHER", "label": "Վճար", "group_type": "OTHER", "group_label": "Այլ", "is_group": false, "color": "#694A5F", "date": "25.11.2019", "time": "11:05", "price": 0, "currency": "֏", "number": "", "traffic": "4ԳԲ" }, { "type": "OTHER", "label": "Վճար", "group_type": "OTHER", "group_label": "Այլ", "is_group": false, "color": "#694A5F", "date": "21.11.2019", "time": "17:03", "price": 0, "currency": "֏", "number": "", "traffic": "200ՄԲ" } ], "topups_sum": 11489, "expenses_sum": 0, "topups_sum_currency": "֏", "expenses_sum_currency": "֏" } };

        this.setState({
            expenses: resolve.data,
            buttonDisabled: false
        });

    }

    getDetalizationTopupsSuccess( resolve ){

        // @test
        // resolve.data = { "status": "OK", "data": { "records": [ { "type": "OTHER", "label": "Վճար", "group_type": "OTHER", "group_label": "Այլ", "is_group": false, "color": "#694A5F", "date": "01.12.2019", "time": "15:25", "price": 11489, "currency": "֏", "number": "", "traffic": "" }, { "type": "OTHER", "label": "Վճար", "group_type": "OTHER", "group_label": "Այլ", "is_group": false, "color": "#694A5F", "date": "02.12.2019", "time": "15:25", "price": 11489, "currency": "֏", "number": "", "traffic": "" } ], "topups_sum": 11489, "expenses_sum": 0, "topups_sum_currency": "֏", "expenses_sum_currency": "֏" } };

        this.setState({
            topups: resolve.data
        });

    }

    redemptionHistorySuccess( resolve ){

        // @test
        // resolve.data = { "status": "OK", "message": "", "data": { "RedemptionLog": [ { "ChannelDesc": "External", "ChannelId": 3, "CustomerId": 0, "CustomerTypeId": null, "DeliveryAddress": null, "Error": null, "FidelityLevelId": null, "Id": 101000000000000125, "ItemsLogs": { "RedemptionItemsLog": { "Cancelled": false, "Command": { "AvailableForBalanceHistory": true, "AvailableForCancellations": false, "AvailableForNotLogging": false, "AvailableForNotifications": true, "AvailableForPrices": false, "AvailableForReasons": false, "AvailableForRestrictions": true, "AvailableForRewards": false, "Description": "Redemption", "ExternalCode": "REDEMPTION", "Id": 20 }, "CommandDateKey": "0001-01-01T00:00:00", "CommandDateTime": "2019-06-21T14:23:34.561", "CustomerId": 0, "DeliveryChannel": { "AreaId": null, "DeliveryChannelTypeId": null, "Description": null, "Enabled": false, "Id": 0, "ShortDescription": "NA" }, "Error": null, "Id": 101001000000000013, "Notes": "", "NumberOfunits": 1, "PhysicalItem": false, "PointsLogs": {}, "PricePointsPerUnit": 400, "PriceProvisioningAmount": "400.00000", "PriceProvisioningPlatformCodeId": null, "ProvisioningPlatformCodeDescription": null, "ProvisioningTransactionId": null, "Reason": null, "RedeemableItem": { "AvailableStock": null, "Description": "SMS դեպի բոլոր ՀՀ բջջային ցանցեր՝ 15 օրով:", "Enabled": false, "Id": 30086, "Image": null, "Name": "50 SMS", "PhysicalItem": false, "ProvisioningAmount": null, "ProvisioningPlatformCodeId": null, "RedeemableItemCatalogue": null, "RedeemableItemCategory": null, "RedeemableItemExternalReferenceId": null, "RedeemableItemPrices": null }, "RedeemableItemId": 30086, "RedemptionLogId": 101000000000000125, "WalletType": { "Description": "Default Points", "ExternalCode": "WALLET_DEFAULT", "Id": 2, "IsDisabled": false, "IsReadOnly": true, "ShortDescription": "Default points" } } }, "RoleId": null, "SendNotification": true, "SourceDesc": "CRM", "SourceExternalReferenceId": 1122, "SourceId": 11, "UserId": 0 }, { "ChannelDesc": "External", "ChannelId": 3, "CustomerId": 0, "CustomerTypeId": null, "DeliveryAddress": null, "Error": null, "FidelityLevelId": null, "Id": 101000000000000109, "ItemsLogs": { "RedemptionItemsLog": { "Cancelled": false, "Command": { "AvailableForBalanceHistory": true, "AvailableForCancellations": false, "AvailableForNotLogging": false, "AvailableForNotifications": true, "AvailableForPrices": false, "AvailableForReasons": false, "AvailableForRestrictions": true, "AvailableForRewards": false, "Description": "Redemption", "ExternalCode": "REDEMPTION", "Id": 20 }, "CommandDateKey": "0001-01-01T00:00:00", "CommandDateTime": "2019-06-21T09:44:44.524", "CustomerId": 0, "DeliveryChannel": { "AreaId": null, "DeliveryChannelTypeId": null, "Description": null, "Enabled": false, "Id": 0, "ShortDescription": "NA" }, "Error": null, "Id": 101001000000000012, "Notes": "", "NumberOfunits": 1, "PhysicalItem": false, "PointsLogs": {}, "PricePointsPerUnit": 400, "PriceProvisioningAmount": "400.00000", "PriceProvisioningPlatformCodeId": null, "ProvisioningPlatformCodeDescription": null, "ProvisioningTransactionId": null, "Reason": null, "RedeemableItem": { "AvailableStock": null, "Description": "SMS դեպի բոլոր ՀՀ բջջային ցանցեր՝ 15 օրով:", "Enabled": false, "Id": 30086, "Image": null, "Name": "50 SMS", "PhysicalItem": false, "ProvisioningAmount": null, "ProvisioningPlatformCodeId": null, "RedeemableItemCatalogue": null, "RedeemableItemCategory": null, "RedeemableItemExternalReferenceId": null, "RedeemableItemPrices": null }, "RedeemableItemId": 30086, "RedemptionLogId": 101000000000000109, "WalletType": { "Description": "Default Points", "ExternalCode": "WALLET_DEFAULT", "Id": 2, "IsDisabled": false, "IsReadOnly": true, "ShortDescription": "Default points" } } }, "RoleId": null, "SendNotification": true, "SourceDesc": "CRM", "SourceExternalReferenceId": 1122, "SourceId": 11, "UserId": 0 }, { "ChannelDesc": "External", "ChannelId": 3, "CustomerId": 0, "CustomerTypeId": null, "DeliveryAddress": null, "Error": null, "FidelityLevelId": null, "Id": 101000000000000108, "ItemsLogs": { "RedemptionItemsLog": { "Cancelled": false, "Command": { "AvailableForBalanceHistory": true, "AvailableForCancellations": false, "AvailableForNotLogging": false, "AvailableForNotifications": true, "AvailableForPrices": false, "AvailableForReasons": false, "AvailableForRestrictions": true, "AvailableForRewards": false, "Description": "Redemption", "ExternalCode": "REDEMPTION", "Id": 20 }, "CommandDateKey": "0001-01-01T00:00:00", "CommandDateTime": "2019-06-21T09:33:23.012", "CustomerId": 0, "DeliveryChannel": { "AreaId": null, "DeliveryChannelTypeId": null, "Description": null, "Enabled": false, "Id": 0, "ShortDescription": "NA" }, "Error": null, "Id": 101001000000000011, "Notes": "", "NumberOfunits": 1, "PhysicalItem": false, "PointsLogs": {}, "PricePointsPerUnit": 400, "PriceProvisioningAmount": "400.00000", "PriceProvisioningPlatformCodeId": null, "ProvisioningPlatformCodeDescription": null, "ProvisioningTransactionId": null, "Reason": null, "RedeemableItem": { "AvailableStock": null, "Description": "SMS դեպի բոլոր ՀՀ բջջային ցանցեր՝ 15 օրով:", "Enabled": false, "Id": 30086, "Image": null, "Name": "50 SMS", "PhysicalItem": false, "ProvisioningAmount": null, "ProvisioningPlatformCodeId": null, "RedeemableItemCatalogue": null, "RedeemableItemCategory": null, "RedeemableItemExternalReferenceId": null, "RedeemableItemPrices": null }, "RedeemableItemId": 30086, "RedemptionLogId": 101000000000000108, "WalletType": { "Description": "Default Points", "ExternalCode": "WALLET_DEFAULT", "Id": 2, "IsDisabled": false, "IsReadOnly": true, "ShortDescription": "Default points" } } }, "RoleId": null, "SendNotification": true, "SourceDesc": "CRM", "SourceExternalReferenceId": 1122, "SourceId": 11, "UserId": 0 }, { "ChannelDesc": "External", "ChannelId": 3, "CustomerId": 0, "CustomerTypeId": null, "DeliveryAddress": null, "Error": null, "FidelityLevelId": null, "Id": 101000000000000105, "ItemsLogs": { "RedemptionItemsLog": { "Cancelled": false, "Command": { "AvailableForBalanceHistory": true, "AvailableForCancellations": false, "AvailableForNotLogging": false, "AvailableForNotifications": true, "AvailableForPrices": false, "AvailableForReasons": false, "AvailableForRestrictions": true, "AvailableForRewards": false, "Description": "Redemption", "ExternalCode": "REDEMPTION", "Id": 20 }, "CommandDateKey": "0001-01-01T00:00:00", "CommandDateTime": "2019-06-20T22:41:58.73", "CustomerId": 0, "DeliveryChannel": { "AreaId": null, "DeliveryChannelTypeId": null, "Description": null, "Enabled": false, "Id": 0, "ShortDescription": "NA" }, "Error": null, "Id": 101001000000000010, "Notes": "", "NumberOfunits": 1, "PhysicalItem": false, "PointsLogs": {}, "PricePointsPerUnit": 400, "PriceProvisioningAmount": "400.00000", "PriceProvisioningPlatformCodeId": null, "ProvisioningPlatformCodeDescription": null, "ProvisioningTransactionId": null, "Reason": null, "RedeemableItem": { "AvailableStock": null, "Description": "SMS դեպի բոլոր ՀՀ բջջային ցանցեր՝ 15 օրով:", "Enabled": false, "Id": 30086, "Image": null, "Name": "50 SMS", "PhysicalItem": false, "ProvisioningAmount": null, "ProvisioningPlatformCodeId": null, "RedeemableItemCatalogue": null, "RedeemableItemCategory": null, "RedeemableItemExternalReferenceId": null, "RedeemableItemPrices": null }, "RedeemableItemId": 30086, "RedemptionLogId": 101000000000000105, "WalletType": { "Description": "Default Points", "ExternalCode": "WALLET_DEFAULT", "Id": 2, "IsDisabled": false, "IsReadOnly": true, "ShortDescription": "Default points" } } }, "RoleId": null, "SendNotification": true, "SourceDesc": "CRM", "SourceExternalReferenceId": 1122, "SourceId": 11, "UserId": 0 }, { "ChannelDesc": "External", "ChannelId": 3, "CustomerId": 0, "CustomerTypeId": null, "DeliveryAddress": null, "Error": null, "FidelityLevelId": null, "Id": 101000000000000103, "ItemsLogs": { "RedemptionItemsLog": { "Cancelled": false, "Command": { "AvailableForBalanceHistory": true, "AvailableForCancellations": false, "AvailableForNotLogging": false, "AvailableForNotifications": true, "AvailableForPrices": false, "AvailableForReasons": false, "AvailableForRestrictions": true, "AvailableForRewards": false, "Description": "Redemption", "ExternalCode": "REDEMPTION", "Id": 20 }, "CommandDateKey": "0001-01-01T00:00:00", "CommandDateTime": "2019-06-20T22:42:07.282", "CustomerId": 0, "DeliveryChannel": { "AreaId": null, "DeliveryChannelTypeId": null, "Description": null, "Enabled": false, "Id": 0, "ShortDescription": "NA" }, "Error": null, "Id": 101001000000000009, "Notes": "", "NumberOfunits": 1, "PhysicalItem": false, "PointsLogs": {}, "PricePointsPerUnit": 400, "PriceProvisioningAmount": "400.00000", "PriceProvisioningPlatformCodeId": null, "ProvisioningPlatformCodeDescription": null, "ProvisioningTransactionId": null, "Reason": null, "RedeemableItem": { "AvailableStock": null, "Description": "SMS դեպի բոլոր ՀՀ բջջային ցանցեր՝ 15 օրով:", "Enabled": false, "Id": 30086, "Image": null, "Name": "50 SMS", "PhysicalItem": false, "ProvisioningAmount": null, "ProvisioningPlatformCodeId": null, "RedeemableItemCatalogue": null, "RedeemableItemCategory": null, "RedeemableItemExternalReferenceId": null, "RedeemableItemPrices": null }, "RedeemableItemId": 30086, "RedemptionLogId": 101000000000000103, "WalletType": { "Description": "Default Points", "ExternalCode": "WALLET_DEFAULT", "Id": 2, "IsDisabled": false, "IsReadOnly": true, "ShortDescription": "Default points" } } }, "RoleId": null, "SendNotification": true, "SourceDesc": "CRM", "SourceExternalReferenceId": 1122, "SourceId": 11, "UserId": 0 }, { "ChannelDesc": "External", "ChannelId": 3, "CustomerId": 0, "CustomerTypeId": null, "DeliveryAddress": null, "Error": null, "FidelityLevelId": null, "Id": 101000000000000102, "ItemsLogs": { "RedemptionItemsLog": { "Cancelled": false, "Command": { "AvailableForBalanceHistory": true, "AvailableForCancellations": false, "AvailableForNotLogging": false, "AvailableForNotifications": true, "AvailableForPrices": false, "AvailableForReasons": false, "AvailableForRestrictions": true, "AvailableForRewards": false, "Description": "Redemption", "ExternalCode": "REDEMPTION", "Id": 20 }, "CommandDateKey": "0001-01-01T00:00:00", "CommandDateTime": "2019-06-20T22:39:09.214", "CustomerId": 0, "DeliveryChannel": { "AreaId": null, "DeliveryChannelTypeId": null, "Description": null, "Enabled": false, "Id": 0, "ShortDescription": "NA" }, "Error": null, "Id": 101001000000000008, "Notes": "", "NumberOfunits": 1, "PhysicalItem": false, "PointsLogs": {}, "PricePointsPerUnit": 400, "PriceProvisioningAmount": "400.00000", "PriceProvisioningPlatformCodeId": null, "ProvisioningPlatformCodeDescription": null, "ProvisioningTransactionId": null, "Reason": null, "RedeemableItem": { "AvailableStock": null, "Description": "SMS դեպի բոլոր ՀՀ բջջային ցանցեր՝ 15 օրով:", "Enabled": false, "Id": 30086, "Image": null, "Name": "50 SMS", "PhysicalItem": false, "ProvisioningAmount": null, "ProvisioningPlatformCodeId": null, "RedeemableItemCatalogue": null, "RedeemableItemCategory": null, "RedeemableItemExternalReferenceId": null, "RedeemableItemPrices": null }, "RedeemableItemId": 30086, "RedemptionLogId": 101000000000000102, "WalletType": { "Description": "Default Points", "ExternalCode": "WALLET_DEFAULT", "Id": 2, "IsDisabled": false, "IsReadOnly": true, "ShortDescription": "Default points" } } }, "RoleId": null, "SendNotification": true, "SourceDesc": "CRM", "SourceExternalReferenceId": 1122, "SourceId": 11, "UserId": 0 }, { "ChannelDesc": "External", "ChannelId": 3, "CustomerId": 0, "CustomerTypeId": null, "DeliveryAddress": null, "Error": null, "FidelityLevelId": null, "Id": 101000000000000062, "ItemsLogs": { "RedemptionItemsLog": { "Cancelled": false, "Command": { "AvailableForBalanceHistory": true, "AvailableForCancellations": false, "AvailableForNotLogging": false, "AvailableForNotifications": true, "AvailableForPrices": false, "AvailableForReasons": false, "AvailableForRestrictions": true, "AvailableForRewards": false, "Description": "Redemption", "ExternalCode": "REDEMPTION", "Id": 20 }, "CommandDateKey": "0001-01-01T00:00:00", "CommandDateTime": "2019-05-24T13:05:40.333", "CustomerId": 0, "DeliveryChannel": { "AreaId": null, "DeliveryChannelTypeId": null, "Description": null, "Enabled": false, "Id": 0, "ShortDescription": "NA" }, "Error": null, "Id": 101001000000000006, "Notes": "", "NumberOfunits": 1, "PhysicalItem": false, "PointsLogs": {}, "PricePointsPerUnit": 400, "PriceProvisioningAmount": "400.00000", "PriceProvisioningPlatformCodeId": null, "ProvisioningPlatformCodeDescription": null, "ProvisioningTransactionId": null, "Reason": null, "RedeemableItem": { "AvailableStock": null, "Description": "SMS դեպի բոլոր ՀՀ բջջային ցանցեր՝ 15 օրով:", "Enabled": false, "Id": 30086, "Image": null, "Name": "50 SMS", "PhysicalItem": false, "ProvisioningAmount": null, "ProvisioningPlatformCodeId": null, "RedeemableItemCatalogue": null, "RedeemableItemCategory": null, "RedeemableItemExternalReferenceId": null, "RedeemableItemPrices": null }, "RedeemableItemId": 30086, "RedemptionLogId": 101000000000000062, "WalletType": { "Description": "Default Points", "ExternalCode": "WALLET_DEFAULT", "Id": 2, "IsDisabled": false, "IsReadOnly": true, "ShortDescription": "Default points" } } }, "RoleId": null, "SendNotification": false, "SourceDesc": "CRM", "SourceExternalReferenceId": 1, "SourceId": 11, "UserId": 0 }, { "ChannelDesc": "External", "ChannelId": 3, "CustomerId": 0, "CustomerTypeId": null, "DeliveryAddress": null, "Error": null, "FidelityLevelId": null, "Id": 101000000000000061, "ItemsLogs": { "RedemptionItemsLog": { "Cancelled": false, "Command": { "AvailableForBalanceHistory": true, "AvailableForCancellations": false, "AvailableForNotLogging": false, "AvailableForNotifications": true, "AvailableForPrices": false, "AvailableForReasons": false, "AvailableForRestrictions": true, "AvailableForRewards": false, "Description": "Redemption", "ExternalCode": "REDEMPTION", "Id": 20 }, "CommandDateKey": "0001-01-01T00:00:00", "CommandDateTime": "2019-05-24T12:43:36.379", "CustomerId": 0, "DeliveryChannel": { "AreaId": null, "DeliveryChannelTypeId": null, "Description": null, "Enabled": false, "Id": 0, "ShortDescription": "NA" }, "Error": null, "Id": 101001000000000005, "Notes": "", "NumberOfunits": 1, "PhysicalItem": false, "PointsLogs": {}, "PricePointsPerUnit": 400, "PriceProvisioningAmount": "400.00000", "PriceProvisioningPlatformCodeId": null, "ProvisioningPlatformCodeDescription": null, "ProvisioningTransactionId": null, "Reason": null, "RedeemableItem": { "AvailableStock": null, "Description": "SMS դեպի բոլոր ՀՀ բջջային ցանցեր՝ 15 օրով:", "Enabled": false, "Id": 30086, "Image": null, "Name": "50 SMS", "PhysicalItem": false, "ProvisioningAmount": null, "ProvisioningPlatformCodeId": null, "RedeemableItemCatalogue": null, "RedeemableItemCategory": null, "RedeemableItemExternalReferenceId": null, "RedeemableItemPrices": null }, "RedeemableItemId": 30086, "RedemptionLogId": 101000000000000061, "WalletType": { "Description": "Default Points", "ExternalCode": "WALLET_DEFAULT", "Id": 2, "IsDisabled": false, "IsReadOnly": true, "ShortDescription": "Default points" } } }, "RoleId": null, "SendNotification": false, "SourceDesc": "CRM", "SourceExternalReferenceId": 1, "SourceId": 11, "UserId": 0 }, { "ChannelDesc": "External", "ChannelId": 3, "CustomerId": 0, "CustomerTypeId": null, "DeliveryAddress": null, "Error": null, "FidelityLevelId": null, "Id": 101000000000000039, "ItemsLogs": { "RedemptionItemsLog": { "Cancelled": false, "Command": { "AvailableForBalanceHistory": true, "AvailableForCancellations": false, "AvailableForNotLogging": false, "AvailableForNotifications": true, "AvailableForPrices": false, "AvailableForReasons": false, "AvailableForRestrictions": true, "AvailableForRewards": false, "Description": "Redemption", "ExternalCode": "REDEMPTION", "Id": 20 }, "CommandDateKey": "0001-01-01T00:00:00", "CommandDateTime": "2019-05-21T07:24:20.766", "CustomerId": 0, "DeliveryChannel": { "AreaId": null, "DeliveryChannelTypeId": null, "Description": null, "Enabled": false, "Id": 0, "ShortDescription": "NA" }, "Error": { "ErrorCode": 810, "ErrorDescription": "Reward not applied", "ErrorLevel": "", "ErrorType": "Technical" }, "Id": 101001000000000004, "Notes": "", "NumberOfunits": 1, "PhysicalItem": false, "PointsLogs": {}, "PricePointsPerUnit": null, "PriceProvisioningAmount": null, "PriceProvisioningPlatformCodeId": null, "ProvisioningPlatformCodeDescription": null, "ProvisioningTransactionId": 101001000000000004, "Reason": null, "RedeemableItem": { "AvailableStock": null, "Description": "SMS դեպի բոլոր ՀՀ բջջային ցանցեր՝ 30 օրով:", "Enabled": false, "Id": 30084, "Image": null, "Name": "150 SMS", "PhysicalItem": false, "ProvisioningAmount": null, "ProvisioningPlatformCodeId": null, "RedeemableItemCatalogue": null, "RedeemableItemCategory": null, "RedeemableItemExternalReferenceId": null, "RedeemableItemPrices": null }, "RedeemableItemId": 30084, "RedemptionLogId": 101000000000000039, "WalletType": { "Description": "Default Points", "ExternalCode": "WALLET_DEFAULT", "Id": 2, "IsDisabled": false, "IsReadOnly": true, "ShortDescription": "Default points" } } }, "RoleId": null, "SendNotification": false, "SourceDesc": "CRM", "SourceExternalReferenceId": 1, "SourceId": 11, "UserId": 0 }, { "ChannelDesc": "External", "ChannelId": 3, "CustomerId": 0, "CustomerTypeId": null, "DeliveryAddress": null, "Error": null, "FidelityLevelId": null, "Id": 101000000000000037, "ItemsLogs": { "RedemptionItemsLog": { "Cancelled": false, "Command": { "AvailableForBalanceHistory": true, "AvailableForCancellations": false, "AvailableForNotLogging": false, "AvailableForNotifications": true, "AvailableForPrices": false, "AvailableForReasons": false, "AvailableForRestrictions": true, "AvailableForRewards": false, "Description": "Redemption", "ExternalCode": "REDEMPTION", "Id": 20 }, "CommandDateKey": "0001-01-01T00:00:00", "CommandDateTime": "2019-05-21T07:23:59.614", "CustomerId": 0, "DeliveryChannel": { "AreaId": null, "DeliveryChannelTypeId": null, "Description": null, "Enabled": false, "Id": 0, "ShortDescription": "NA" }, "Error": null, "Id": 101001000000000003, "Notes": "", "NumberOfunits": 1, "PhysicalItem": false, "PointsLogs": {}, "PricePointsPerUnit": 1, "PriceProvisioningAmount": null, "PriceProvisioningPlatformCodeId": null, "ProvisioningPlatformCodeDescription": null, "ProvisioningTransactionId": null, "Reason": null, "RedeemableItem": { "AvailableStock": null, "Description": "Զանգեր դեպի բոլոր ՀՀ բջջային ցանցեր՝ 15 օրով:", "Enabled": false, "Id": 30085, "Image": null, "Name": "10 րոպե", "PhysicalItem": false, "ProvisioningAmount": null, "ProvisioningPlatformCodeId": null, "RedeemableItemCatalogue": null, "RedeemableItemCategory": null, "RedeemableItemExternalReferenceId": null, "RedeemableItemPrices": null }, "RedeemableItemId": 30085, "RedemptionLogId": 101000000000000037, "WalletType": { "Description": "Default Points", "ExternalCode": "WALLET_DEFAULT", "Id": 2, "IsDisabled": false, "IsReadOnly": true, "ShortDescription": "Default points" } } }, "RoleId": null, "SendNotification": false, "SourceDesc": "CRM", "SourceExternalReferenceId": 1, "SourceId": 11, "UserId": 0 }, { "ChannelDesc": "External", "ChannelId": 3, "CustomerId": 0, "CustomerTypeId": null, "DeliveryAddress": null, "Error": null, "FidelityLevelId": null, "Id": 101000000000000036, "ItemsLogs": { "RedemptionItemsLog": { "Cancelled": false, "Command": { "AvailableForBalanceHistory": true, "AvailableForCancellations": false, "AvailableForNotLogging": false, "AvailableForNotifications": true, "AvailableForPrices": false, "AvailableForReasons": false, "AvailableForRestrictions": true, "AvailableForRewards": false, "Description": "Redemption", "ExternalCode": "REDEMPTION", "Id": 20 }, "CommandDateKey": "0001-01-01T00:00:00", "CommandDateTime": "2019-05-21T07:23:48.871", "CustomerId": 0, "DeliveryChannel": { "AreaId": null, "DeliveryChannelTypeId": null, "Description": null, "Enabled": false, "Id": 0, "ShortDescription": "NA" }, "Error": { "ErrorCode": 810, "ErrorDescription": "Reward not applied", "ErrorLevel": "", "ErrorType": "Technical" }, "Id": 101001000000000002, "Notes": "", "NumberOfunits": 1, "PhysicalItem": false, "PointsLogs": {}, "PricePointsPerUnit": null, "PriceProvisioningAmount": null, "PriceProvisioningPlatformCodeId": null, "ProvisioningPlatformCodeDescription": null, "ProvisioningTransactionId": 101001000000000002, "Reason": null, "RedeemableItem": { "AvailableStock": null, "Description": "SMS դեպի բոլոր ՀՀ բջջային ցանցեր՝ 30 օրով:", "Enabled": false, "Id": 30084, "Image": null, "Name": "150 SMS", "PhysicalItem": false, "ProvisioningAmount": null, "ProvisioningPlatformCodeId": null, "RedeemableItemCatalogue": null, "RedeemableItemCategory": null, "RedeemableItemExternalReferenceId": null, "RedeemableItemPrices": null }, "RedeemableItemId": 30084, "RedemptionLogId": 101000000000000036, "WalletType": { "Description": "Default Points", "ExternalCode": "WALLET_DEFAULT", "Id": 2, "IsDisabled": false, "IsReadOnly": true, "ShortDescription": "Default points" } } }, "RoleId": null, "SendNotification": false, "SourceDesc": "CRM", "SourceExternalReferenceId": 1, "SourceId": 11, "UserId": 0 }, { "ChannelDesc": "External", "ChannelId": 3, "CustomerId": 0, "CustomerTypeId": null, "DeliveryAddress": null, "Error": null, "FidelityLevelId": null, "Id": 101000000000000035, "ItemsLogs": { "RedemptionItemsLog": { "Cancelled": false, "Command": { "AvailableForBalanceHistory": true, "AvailableForCancellations": false, "AvailableForNotLogging": false, "AvailableForNotifications": true, "AvailableForPrices": false, "AvailableForReasons": false, "AvailableForRestrictions": true, "AvailableForRewards": false, "Description": "Redemption", "ExternalCode": "REDEMPTION", "Id": 20 }, "CommandDateKey": "0001-01-01T00:00:00", "CommandDateTime": "2019-05-21T07:23:37.372", "CustomerId": 0, "DeliveryChannel": { "AreaId": null, "DeliveryChannelTypeId": null, "Description": null, "Enabled": false, "Id": 0, "ShortDescription": "NA" }, "Error": { "ErrorCode": 810, "ErrorDescription": "Reward not applied", "ErrorLevel": "", "ErrorType": "Technical" }, "Id": 101001000000000001, "Notes": "", "NumberOfunits": 1, "PhysicalItem": false, "PointsLogs": {}, "PricePointsPerUnit": null, "PriceProvisioningAmount": null, "PriceProvisioningPlatformCodeId": null, "ProvisioningPlatformCodeDescription": null, "ProvisioningTransactionId": 101001000000000001, "Reason": null, "RedeemableItem": { "AvailableStock": null, "Description": "SMS դեպի բոլոր ՀՀ բջջային ցանցեր՝ 15 օրով:", "Enabled": false, "Id": 30083, "Image": null, "Name": "100 SMS", "PhysicalItem": false, "ProvisioningAmount": null, "ProvisioningPlatformCodeId": null, "RedeemableItemCatalogue": null, "RedeemableItemCategory": null, "RedeemableItemExternalReferenceId": null, "RedeemableItemPrices": null }, "RedeemableItemId": 30083, "RedemptionLogId": 101000000000000035, "WalletType": { "Description": "Default Points", "ExternalCode": "WALLET_DEFAULT", "Id": 2, "IsDisabled": false, "IsReadOnly": true, "ShortDescription": "Default points" } } }, "RoleId": null, "SendNotification": false, "SourceDesc": "CRM", "SourceExternalReferenceId": 1, "SourceId": 11, "UserId": 0 } ] } };

        this.setState({
            redemptionHistory: resolve.data
        });

    }

    balanceHistorySuccess( resolve ){

        if ( !this.componentIsMounted ) {
            return;
        }

        // @test
        // resolve.data = {"status":"OK","message":"","data":{"BalanceLog":[{"Channel":"Mobile App","CommandDatetime":"2019-12-20T20:09:34.663","CommandDescription":"Customer registration","Points":200,"Source":"EXTERNAL","SourceDesc":"External","ValidFrom":"2019-12-20T20:09:34.659","ValidTo":"2020-12-31T23:59:59.999","WalletType":"Default points"},{"Channel":"CRM","CommandDatetime":"2019-12-23T10:42:08.887","CommandDescription":"Add points","Points":1500,"Source":"EXTERNAL","SourceDesc":"External","ValidFrom":"2019-12-23T10:42:08.886","ValidTo":"2020-12-31T23:59:59.999","WalletType":"Default points"},{"Channel":"CRM","CommandDatetime":"2019-12-23T10:42:16.104","CommandDescription":"Redemption","Points":-1000,"Source":"EXTERNAL","SourceDesc":"External","ValidFrom":null,"ValidTo":null,"WalletType":"Default points"},{"Channel":"Mobile App","CommandDatetime":"2019-12-27T16:50:40.059","CommandDescription":"Redemption","Points":-400,"Source":"EXTERNAL","SourceDesc":"External","ValidFrom":null,"ValidTo":null,"WalletType":"Default points"}]}};

        this.setState({
            balanceHistory: resolve.data
        });

    }

    getFilteredData( event ){

        this.setState({
            buttonDisabled: true,
            expenses: '',
            topups: '',
            redemptionHistory: '',
            balanceHistory: '',
            allowedScrollNumber: 20,
            allowedTopupsScrollNumber: 10,
            allowedBonusScrollNumber: 10,
            allowedBonusStockPointsScrollNumber: 10
        });

        let fromDate = this.state.startDate,
            toDate = this.state.endDate,
            ctn = '';

        if ( this.props.ctn.status === 'OK' && this.props.ctn.data.hasOwnProperty('info') ) {
            ctn = this.props.ctn.data.subscriber.toString().replace(/^374/, '');
        }

        if ( this.state.selectedOption && this.state.selectedOption.value !== 'custom' ) {

            let d = new Date();

            toDate = new Date();
            fromDate = new Date( d.setDate( d.getDate() - this.state.selectedOption.value ) );

        }

        if ( fromDate ) {
            fromDate = fromDate.getFullYear() + '-' + doubleNumber( fromDate.getMonth()+1 ) + '-' + doubleNumber( fromDate.getDate());
        }

        if ( toDate ) {
            toDate = toDate.getFullYear() + '-' + doubleNumber( toDate.getMonth()+1 ) + '-' + doubleNumber( toDate.getDate());
        }

        let sendData = {
                jwt: this.props.getDecryptedToken(),
                from_date: fromDate,
                to_date: toDate,
                format: 'json',
                ctn
            },
            filtersGroupCounter = 0;

        for ( let i in this.state.filtersGroup ) {
            if ( this.state.filtersGroup[i] ) {
                sendData['f[' + filtersGroupCounter++ + ']'] = i;
            }
        }

        // Get expenses list
        ApiManager.getRequest(
            sendData,
            '/b2b' + this.props.curator + '/detalization/expenses'
        ).then(this.getDetalizationExpensesSuccess, this.errorCallBack);

        // Get topups list
        ApiManager.getRequest(
            sendData,
            '/b2b' + this.props.curator + '/detalization/topups'
        ).then(this.getDetalizationTopupsSuccess, this.errorCallBack);

        // Get available category items
        ApiManager.postRequest({
            _token: this.props.csrf_token.data,
            jwt: this.props.getDecryptedToken(),
            source: 'WEB',
            channel: 'EXTERNAL',
            externalReferenceId: 1,
            subscriberId: '74' + ctn,
            subscriberIdType: 'Msisdn',
            language: localStorageGetItem('defaultLngPrefix').toUpperCase(),
            walletType: 'WALLET_DEFAULT',
            startDate: fromDate,
            endDate: toDate
        }, '/b2b' + this.props.curator + '/redemption-history').then(this.redemptionHistorySuccess, this.errorCallBack);

        // Get query stock points
        ApiManager.postRequest({
            _token: this.props.csrf_token.data,
            jwt: this.props.getDecryptedToken(),
            subscriberId: '74' + ctn
        }, '/b2b' + this.props.curator + '/balance-history').then(this.balanceHistorySuccess, this.errorCallBack);

        event.preventDefault();

    }

    expensesFiltersList(){

        let result = (
            <div className="main-wrapper__progress-box">
                <ul className="progress-list">
                    <li className="progress-list__item progress-list__item--full">{trans( this.props.b2bTrans, 'b2b.history.graphics.empty_message' )}</li>
                </ul>
            </div>
        );

        if ( this.state.expenses !== '' && this.state.expenses.status === 'OK' && this.state.expenses.data.records.length ) {

            let grouping = groupByKey(this.state.expenses.data.records, 'type'),
                groupedPrice = {},
                totalCount = 0,
                groupedItems = Object.keys(grouping);

            groupedItems.map((item) => {

                //if ( groupedItems.length > 5 && item === 'OTHER' ) {
                //    return '';
                //}

                if (!groupedPrice.hasOwnProperty(item)) {
                    groupedPrice[item] = {
                        count: 0,
                        label: '',
                        color: '',
                        currency: ''
                    };
                }

                grouping[item].map((groupItem) => {
                    groupedPrice[item]['count'] += Number(groupItem['price']);

                    if (groupedPrice[item]['label'] === '') {
                        groupedPrice[item]['label'] = groupItem['group_label'];
                    }

                    if (groupedPrice[item]['color'] === '') {
                        groupedPrice[item]['color'] = groupItem['color'];
                    }

                    if (groupedPrice[item]['currency'] === '') {
                        groupedPrice[item]['currency'] = groupItem['currency'];
                    }

                    return groupedPrice;

                });

                return totalCount += groupedPrice[item]['count'];

            });

            const progressItems = Object.keys(groupedPrice).map((item, index) => {

                let groupItem = groupedPrice[item];

                return (
                    <li className="progress-list__item ver-top-box" key={index}>
                        <div className="progress-list__circle pr">
                            <Circle
                                params={{
                                    start: 421,
                                    height: 158,
                                    width: 158,
                                    cx: 79,
                                    cy: 79,
                                    radius: 67,
                                    strokeWidth: 22,
                                    fill: 'transparent',
                                    count: groupItem.count,
                                    color: groupItem.color,
                                    totalCount: totalCount
                                }}
                            />
                            <div
                                className="progress-list__price fb fs20 pr"
                                style={{
                                    color: groupItem.color
                                }}>{setComoAfterThirdSymbol( Math.round( groupItem.count ) ) + ' ' + groupItem.currency}</div>
                        </div>
                        <h3
                            className="progress-list__title fb tu"
                            style={{
                                color: groupItem.color
                            }}
                        >{groupItem.label}</h3>
                    </li>
                );

            });

            result = (
                <div className="main-wrapper__progress-box">
                    <ul className="progress-list tc">{progressItems}</ul>
                </div>
            );

        }

        if ( this.state.buttonDisabled ) {
            result = <Loading withBox={true} />;
        }

        if ( this.state.expenses !== '' && this.state.expenses.status === 'ERROR' ) {
            result = <p className="error-message">{this.state.expenses.message}</p>;
        }

        return (
            <section className="main-wrapper__services main-wrapper__services--with-space">
                <div className="main-wrapper__services-title-box pr">
                    <h2 className="main-wrapper__sub-title main-wrapper__sub-title--graphics monserrat-medium tl pr sprite-b trans-background">{trans( this.props.b2bTrans, 'b2b.history.graphics.title' )}</h2>
                </div>
                {result}
            </section>
        );

    }

    topupsList(){

        let result = (
                <div className="main-wrapper__list-out">
                    <ul className="list list--inclusions">
                        <li className="list__item">
                            <div className="list__link">
                                <div className="list__inner-info--dark">{trans( this.props.b2bTrans, 'b2b.history.topups.empty_message' )}</div>
                            </div>
                        </li>
                    </ul>
                </div>
            ),
            radiusClass = '',
            sum = '';

        if ( this.state.topups !== '' && this.state.topups.status === 'OK' && this.state.topups.data.records.length ) {

            let grouping = groupByKey(this.state.topups.data.records, 'date'),
                groupedPrice = {},
                totalCount = 0,
                groupedItems = Object.keys(grouping),
                historyIndex = 1;

            groupedItems
                .sort( ( a, b ) => new Date(b) - new Date(a) )
                .map((item) => {

                    if (!groupedPrice.hasOwnProperty(item)) {
                        groupedPrice[item] = {
                            price: 0,
                            currency: ''
                        };
                    }

                    grouping[item].map((groupItem) => {
                        groupedPrice[item]['price'] += Number(groupItem['price']);

                        if (groupedPrice[item]['currency'] === '') {
                            groupedPrice[item]['currency'] = groupItem['currency'];
                        }

                        return groupedPrice;
                    });
                    return totalCount += groupedPrice[item]['price'];

                });

            const progressItems = Object.keys(groupedPrice).map((item, index) => {

                if ( this.state.allowedTopupsScrollNumber < historyIndex ) {
                    return '';
                }

                historyIndex++;

                let groupItem = groupedPrice[item];

                return (
                    <li className="list__item" key={index}>
                        <div className="list__link pr clear-fix">
                            <div className="list__inner-info ver-top-box tl">{item}</div>
                            <div className="list__inner-info fb ver-top-box tr">{setComoAfterThirdSymbol(Math.round( groupItem.price ))} {groupItem.currency}</div>
                        </div>
                    </li>
                );

            });

            result = (
                <div
                    className="main-wrapper__list-out main-wrapper__list-out--small scroller-block"
                    onScroll={( event ) => this.scrollHandler( event, historyIndex, 'allowedTopupsScrollNumber' )}
                >
                    <ul className="list list--inclusions">{progressItems}</ul>
                </div>
            );

            sum = (
                <div className="main-wrapper__total-box tc">
                    <span className="main-wrapper__total-title ver-top-box">{trans( this.props.b2bTrans, 'b2b.history.topups.sum_label' )}</span>
                    <strong className="main-wrapper__total-sum fs20 ver-top-box">{setComoAfterThirdSymbol(Math.round(this.state.topups.data.topups_sum))} {this.state.topups.data.topups_sum_currency}</strong>
                </div>
            );

            radiusClass = ' main-wrapper__services--none-bottom-radius';

        }

        if ( this.state.buttonDisabled ) {
            result = <Loading withBox={true} />;
        }

        if ( this.state.topups !== '' && this.state.topups.status === 'ERROR' ) {
            result = <p className="error-message">{this.state.topups.message}</p>;
        }

        return (
            <div className="main-wrapper__double-list-item ver-top-box">
                <section className={`main-wrapper__services${radiusClass}`}>
                    <h2 className="main-wrapper__sub-title main-wrapper__sub-title--plus monserrat-medium pr sprite-b">{trans( this.props.b2bTrans, 'b2b.history.apps.title' )}</h2>
                    {result}
                </section>
                {sum}
            </div>
        );

    }

    scrollHandler( event, count, stateName ){

        if (
            (event.target.scrollTop + event.target.offsetHeight > event.target.scrollHeight - 50) &&
            ( count > this.state[stateName] )
        ) {
            let newState = {};

            newState[stateName] = this.state[stateName] + this.state.allowedScrollAddNumber;

            this.setState( newState );
        }

    }

    expensesList(){

        let result = (
                <div className="main-wrapper__list-out main-wrapper__list-out--services-big">
                    <div className="list list--inclusions">
                        <div className="list__item">
                            <div className="list__link">
                                <div className="list__inner-info--dark">{trans( this.props.b2bTrans, 'b2b.history.expenses.empty_message' )}</div>
                            </div>
                        </div>
                    </div>
                </div>
            ),
            radiusClass = '',
            sum = '';

        if ( this.state.expenses !== '' && this.state.expenses.status === 'OK' && this.state.expenses.data.records.length ) {

            let grouping = groupByKey(this.state.expenses.data.records, 'date'),
                groupedItems = Object.keys(grouping),
                historyIndex = 1;

            const groupList = groupedItems
                .sort( ( a, b ) => new Date(a.split('.').reverse().join(' ')) - new Date(b.split('.').reverse().join(' ')) )
                .map((item, index) => {

                    if ( this.state.allowedScrollNumber < historyIndex ) {
                        return '';
                    }

                    let innerGrouping = groupByKey(grouping[item], 'type'),
                        innerGroupedItems = Object.keys(innerGrouping);

                    const progressItems = innerGroupedItems.map((item1) => {

                        let groupedPrice = {},
                            groupBox = '',
                            state = 'historyGroupItem' + historyIndex++;

                        // Group getter

                        if ( this.state.hasOwnProperty(state) && this.state[state] ) {

                            groupBox = innerGrouping[item1]
                                .sort( ( a, b ) => new Date(a.date + ' ' + a.time) - new Date(b.date + ' ' + b.time) )
                                .map(( item2, index2 ) => {
                                    return (
                                        <div className="list__item" key={index2}>
                                            <div className="list__link pr">

                                                <div className="list__services-first">
                                                    <div className="list__inner-info list__inner-info--dark fb">{item2.number} </div>
                                                    <p className="list__inner-info fs14">{item2.time}</p>
                                                </div>

                                                <div className="list__services-second tr">
                                                    <div className="list__inner-info--dark fb">{item2.price} {item2.currency}</div>
                                                    <p className="list__inner-time fs14">{item2.traffic}</p>
                                                </div>

                                            </div>
                                        </div>
                                    );
                                });

                            groupBox = <div className="list__group">{groupBox}</div>;

                        }

                        // Button getter

                        if ( !groupedPrice.hasOwnProperty(item1) ) {
                            groupedPrice[item1] = {
                                price: 0,
                                label: '',
                                color: '',
                                currency: ''
                            };
                        }

                        innerGrouping[item1].map((groupItem) => {
                            groupedPrice[item1]['price'] += Number(groupItem['price']);

                            if (groupedPrice[item1]['label'] === '') {
                                groupedPrice[item1]['label'] = groupItem['label'];
                            }

                            if (groupedPrice[item1]['color'] === '') {
                                groupedPrice[item1]['color'] = groupItem['color'];
                            }

                            if (groupedPrice[item1]['currency'] === '') {
                                groupedPrice[item1]['currency'] = groupItem['currency'];
                            }

                            return true;
                        });

                        return Object.keys(groupedPrice).map((item3, stateIndex) => {

                            let groupItem = groupedPrice[item3],
                                groupState = this.state.hasOwnProperty(state) && this.state[state];

                            historyIndex++;

                            if ( this.state.onlyPaid && groupItem.price === 0 ) {
                                return '';
                            }

                            return (
                                <div key={stateIndex}>
                                    <button
                                        className={`list__item list__item--group full-width tl${groupState ? ' list__item--group-active' : ''}`}
                                        type="button"
                                        style={{ backgroundColor: groupItem.color }}
                                        onClick={() => {
                                            let newState = {};
                                            newState[state] = !groupState;
                                            this.setState( newState );
                                        }}
                                    >

                                    <span className="list__link db pr sprite-a list__link--white-bg">
                                        <span className="list__circle db center-center" style={{ backgroundColor: groupItem.color }}> </span>
                                        <span className="list__services-first db">
                                            <span className="list__inner-info list__inner-info--dark db">{groupItem.label}</span>
                                        </span>
                                        <span className="list__services-second db tr">
                                            <span className="list__inner-info--dark db fb">{setComoAfterThirdSymbol(Math.round( groupItem.price ))} {groupItem.currency}</span>
                                        </span>
                                    </span>
                                    </button>
                                    {groupBox}
                                </div>
                            );

                        });

                    });

                    return (
                        <div key={index}>
                            <div className="list__item list__item--title monserrat-medium">{item}</div>
                            {progressItems}
                        </div>
                    );

                });

            result = (
                <div
                    className="main-wrapper__list-out main-wrapper__list-out--services-big scroller-block"
                    onScroll={( event ) => this.scrollHandler( event, historyIndex, 'allowedScrollNumber' )}
                >
                    <div className="list list--double list--inner mb-none">{groupList}</div>
                </div>
            );

            sum = (
                <div className="main-wrapper__total-box tc">
                    <span className="main-wrapper__total-title ver-top-box">{trans( this.props.b2bTrans, 'b2b.history.expenses.sum_label' )}</span>
                    <strong className="main-wrapper__total-sum fs20 ver-top-box">{setComoAfterThirdSymbol(Math.round(this.state.expenses.data.expenses_sum))} {this.state.expenses.data.expenses_sum_currency}</strong>
                </div>
            );

            radiusClass = ' main-wrapper__services--details main-wrapper__services--none-bottom-radius';

        }

        if ( this.state.buttonDisabled ) {
            result = <Loading withBox={true} />;
        }

        if ( this.state.expenses !== '' && this.state.expenses.status === 'ERROR' ) {
            result = <p className="error-message">{this.state.expenses.message}</p>;
        }

        return (

            <>
                <section className={`main-wrapper__services${radiusClass}`}>
                    <h2 className="main-wrapper__sub-title main-wrapper__sub-title--history monserrat-medium pr sprite-b">{trans( this.props.b2bTrans, 'b2b.history.deciphering.title' )}</h2>
                    {result}
                </section>
                {sum}
            </>

        );

    }

    accumulatedPoints(){

        let listItems = (
            <div className="main-wrapper__list-out main-wrapper__list-out--medium">
                <ul className="list list--double list--accumulated">
                    <li className="list__item">
                        <div className="list__link">
                            <div className="list__inner-info--dark">{trans( this.props.b2bTrans, 'b2b.bonus.expended.empty_message' )}</div>
                        </div>
                    </li>
                </ul>
            </div>
        );

        if ( this.state.balanceHistory !== '' && this.state.balanceHistory.status === 'OK' ) {

            if ( this.state.balanceHistory.data.hasOwnProperty('BalanceLog') && this.state.balanceHistory.data.BalanceLog.length ) {

                const groupedItems = {};

                this.state.balanceHistory.data.BalanceLog.map(( item ) => {

                    if ( item.Points < 0 ) {
                        return '';
                    }

                    const date = new Date( item.CommandDatetime );
                    const newDate = doubleNumber( date.getDate() ) + '.' + doubleNumber( date.getMonth()+1 ) + '.' + date.getFullYear().toString().substr(-2);
                    const time = doubleNumber( date.getHours() ) + ':' + doubleNumber( date.getMinutes() );
                    const data = {
                        point: item.Points,
                        time: time,
                        date
                    };

                    return groupedItems.hasOwnProperty( newDate ) ? groupedItems[newDate].push( data ) : groupedItems[newDate] = [ data ];
                });

                let itemKey = 0;

                listItems = [];

                Object.keys(groupedItems)
                    .sort()
                    .map(( item ) => {

                        if ( this.state.allowedBonusStockPointsScrollNumber < itemKey ) {
                            return listItems;
                        }

                        listItems.push(<li className="list__item list__item--title monserrat-medium" key={itemKey}>{item}</li>);

                        groupedItems[item].sort((a, b) => new Date(b.date) - new Date(a.date)).map(( groupItem ) => {

                            itemKey++;

                            return listItems.push(
                                <li className="list__item" key={itemKey}>
                                    <div className="list__link list__link--space-24 pr clear-fix">
                                        <div className="list__inner-info list__inner-info--dark fb ver-top-box tl">{groupItem.point} {trans(this.props.b2bTrans, 'b2b.bonus.expended.points_title')}</div>
                                        <div className="list__inner-info fs14 ver-top-box tr">{groupItem.time}</div>
                                    </div>
                                </li>
                            );

                        });

                        itemKey++;

                        return listItems;

                    });

                listItems = (
                    <div
                        className="main-wrapper__list-out main-wrapper__list-out--medium scroller-block"
                        onScroll={( event ) => this.scrollHandler( event, itemKey, 'allowedBonusStockPointsScrollNumber' )}
                    >
                        <ul className="list list--double list--accumulated">{listItems}</ul>
                    </div>
                );

            }

        }

        if ( this.state.buttonDisabled ) {
            listItems = <Loading withBox={true} />;
        }

        if ( this.state.balanceHistory !== '' && this.state.balanceHistory.status === 'ERROR' ) {
            listItems = <p className="error-message">{this.state.balanceHistory.message}</p>;
        }

        return listItems;

    }

    resetDatepickers(){

        // this.startDate = new Date();

        this.setState({
            // startDate: new Date( this.startDate.setDate(this.startDate.getDate() - 1) ),
            // endDate: new Date(),
            showModal: false,
            modalButtonDisabled: false
        });

    }

    sendReportToEmail( event ){

        this.setState({
            modalButtonDisabled: true
        });

        let fromDate = this.state.startDate,
            toDate = this.state.endDate,
            ctn = '';

        if ( this.props.ctn.status === 'OK' && this.props.ctn.data.hasOwnProperty('info') ) {
            ctn = this.props.ctn.data.subscriber.toString().replace(/^374/, '');
        }

        if ( fromDate ) {
            fromDate = fromDate.getFullYear() + '-' + doubleNumber( fromDate.getMonth()+1 ) + '-' + doubleNumber( fromDate.getDate());
        }

        if ( toDate ) {
            toDate = toDate.getFullYear() + '-' + doubleNumber( toDate.getMonth()+1 ) + '-' + doubleNumber( toDate.getDate());
        }

        // Send email report file
        ApiManager.getRequest({
                jwt: this.props.getDecryptedToken(),
                from_date: fromDate,
                to_date: toDate,
                email: this.state.email,
                format: this.state.fileType,
                ctn
            }, '/b2b' + this.props.curator + '/detalization/expenses'
        ).then(this.sendEmailExpensesDataSuccess, this.errorCallBack);

        event.preventDefault();

    }

    sendEmailExpensesDataSuccess( resolve ){

        this.setState({
            modalButtonDisabled: false,
            modalResponseData: resolve.data
        });

        if ( resolve.data.status === 'OK' ) {
            this.resetDatepickers();
            this.setState({ showSuccessModal: true });
        }

    }

    emailModal(){

        if ( !this.state.showModal ) {
            return '';
        }

        let errorEmailClass = '',
            errorEmailBox = '',
            errorBox = '';

        if ( this.state.modalResponseData !== '' ) {

            if ( this.state.modalResponseData.status === 'INVALID_DATA' ) {

                if ( this.state.modalResponseData.errors.hasOwnProperty('email') ) {
                    errorEmailClass = ' form-error';
                    errorEmailBox = <div className="form-error-text fs11">{this.state.modalResponseData.errors.email}</div>;
                }

                if ( this.state.modalResponseData.errors.hasOwnProperty('token') ) {
                    errorBox = <FormMiddlewareError message={this.state.modalResponseData.errors.token} />;
                }

            }

            if ( this.state.modalResponseData.status === 'ERROR' || this.state.modalResponseData.status === 'NOT_FOUND' ) {

                errorBox = <FormMiddlewareError message={this.state.modalResponseData.message} />;

            }

        }

        return (

            <div className="modal modal--full fade show scroller-block">
                <div className="modal__content modal-dialog pr">
                    <div className="table">
                        <div className="table-cell">
                            <div className="modal__inner pr">

                                <h3 className="modal__title monserrat-medium fs36 tc">{trans( this.props.b2bTrans, 'b2b.history.modal.title' )}</h3>

                                <p className="modal__description fs13 tc">{trans( this.props.b2bTrans, 'b2b.history.modal.description' )}</p>

                                <form action="#" method="post" onSubmit={( event ) => this.sendReportToEmail( event )}>
                                    <div className={`form__form-box${errorEmailClass}`}>
                                        <label className="form__label db fs11" htmlFor="email">{trans( this.props.b2bTrans, 'b2b.history.modal.email_label' )}</label>
                                        <div className="form__field-out pr">
                                            <input
                                                className="form__field fs13"
                                                id="email"
                                                type="text"
                                                name="email"
                                                value={this.state.email}
                                                onChange={( event ) => this.setState({ email: event.target.value.trim() })}
                                            />
                                        </div>
                                        {errorEmailBox}
                                    </div>

                                    <div className="form__form-box">
                                        <label className="form__label db fs11" htmlFor="email">{trans( this.props.b2bTrans, 'b2b.history.modal.file_label' )}</label>
                                        <div className="form__radio-group">
                                            <input
                                                className="form__radio dn"
                                                name="type-radio"
                                                type="radio"
                                                id="type-1"
                                                checked={this.state.fileType === 'pdf'}
                                                onChange={() => this.setState({ fileType: 'pdf' })}
                                            />
                                            <label className="form__radio-label fs12 ver-top-box pr" htmlFor="type-1">{trans( this.props.b2bTrans, 'b2b.history.modal.file_pdf_label' )}</label>
                                            <input
                                                className="form__radio dn"
                                                name="type-radio"
                                                type="radio"
                                                id="type-2"
                                                checked={this.state.fileType === 'excel'}
                                                onChange={() => this.setState({ fileType: 'excel' })}
                                            />
                                            <label className="form__radio-label fs12 ver-top-box pr" htmlFor="type-2">{trans( this.props.b2bTrans, 'b2b.history.modal.file_excel_label' )}</label>
                                        </div>
                                    </div>

                                    {errorBox}

                                    <button
                                        className={`modal__submit-btn btn btn--with-space btn--yellow${this.state.modalButtonDisabled ? ' btn--loading' : ''}`}
                                        type="submit"
                                        disabled={this.state.modalButtonDisabled}
                                    >{trans( this.props.b2bTrans, 'b2b.history.modal.send_title' )}</button>

                                    <button
                                        className="modal__cancel-btn btn btn--white"
                                        type="button"
                                        onClick={() => this.resetDatepickers()}
                                    >{trans( this.props.b2bTrans, 'b2b.history.modal.cancel_title' )}</button>

                                </form>

                            </div>
                        </div>
                    </div>
                </div>
            </div>

        );

    }

    emailSuccessModal(){

        if ( !this.state.showSuccessModal ) {
            return '';
        }

        return (
            <Modal
                title={trans(this.props.b2bTrans, 'b2b.history.success_modal.title')}
                description={trans(this.props.b2bTrans, 'b2b.history.success_modal.description')}
                agreeText={trans(this.props.b2bTrans, 'b2b.history.success_modal.agree')}
                agreeAction={() => this.setState({ showSuccessModal: false })}
                className="modal--full"
            />
        );

    }

    errorModal(){

        if ( !this.state.showErrorModal ) {
            return '';
        }

        return (
            <ErrorModal
                title={trans( this.props.b2bTrans, 'b2b.error.modal.title' )}
                description={trans( this.props.b2bTrans, 'b2b.error.modal.description' )}
                action_text={trans( this.props.b2bTrans, 'b2b.error.modal.action_text' )}
            />
        );

    }

    expendedPoints(){

        let listItems = (
                <div className="main-wrapper__list-out main-wrapper__list-out--medium scroller-block">
                    <ul className="list list--double">
                        <li className="list__item">
                            <div className="list__link">
                                <div className="list__inner-info--dark">{trans( this.props.b2bTrans, 'b2b.history.expended.empty_message' )}</div>
                            </div>
                        </li>
                    </ul>
                </div>
            ),

            detailsClass = '';

        if ( this.state.redemptionHistory !== '' && this.state.redemptionHistory.status === 'OK' ) {

            if ( this.state.redemptionHistory.data.hasOwnProperty('RedemptionLog') && this.state.redemptionHistory.data.RedemptionLog.length ) {

                detailsClass = ' main-wrapper__services--details main-wrapper__services--info';

                const groupedItems = {};

                this.state.redemptionHistory.data.RedemptionLog.map(( item ) => {

                    const date = new Date( item.ItemsLogs.RedemptionItemsLog.CommandDateTime );
                    const newDate = doubleNumber( date.getDate() ) + '.' + doubleNumber( date.getMonth()+1 ) + '.' + date.getFullYear().toString().substr(-2);
                    const time = doubleNumber( date.getHours() ) + ':' + doubleNumber( date.getMinutes() );
                    const data = {
                        name: item.ItemsLogs.RedemptionItemsLog.RedeemableItem.Name,
                        point: item.ItemsLogs.RedemptionItemsLog.PricePointsPerUnit,
                        time: time,
                        date
                    };

                    return groupedItems.hasOwnProperty( newDate ) ? groupedItems[newDate].push( data ) : groupedItems[newDate] = [ data ];
                });

                let itemKey = 0;

                listItems = [];

                Object.keys(groupedItems)
                    .sort()
                    .map(( item ) => {

                        if ( this.state.allowedBonusScrollNumber < itemKey ) {
                            return listItems;
                        }

                        listItems.push(<li className="list__item list__item--title monserrat-medium" key={itemKey}>{item}</li>);

                        groupedItems[item]
                            .sort((a, b) => new Date(b.date) - new Date(a.date))
                            .map(( groupItem ) => {

                                itemKey++;

                                return listItems.push(
                                    <li className="list__item" key={itemKey}>
                                        <div className="list__link list__link--space-24 pr">
                                            <div className="list__services-first">
                                                <div className="list__inner-info list__inner-info--dark fb">{groupItem.name}</div>
                                                <p className="list__inner-info fs14">{groupItem.time}</p>
                                            </div>
                                            <div className="list__services-second">
                                                <div className="list__inner-info--dark fb">{groupItem.point} {trans(this.props.b2bTrans, 'b2b.bonus.tab.points_title')}</div>
                                            </div>
                                        </div>
                                    </li>
                                );

                            });

                        itemKey++;

                        return listItems;

                    });

                listItems = (
                    <div
                        className="main-wrapper__list-out main-wrapper__list-out--medium scroller-block"
                        onScroll={( event ) => this.scrollHandler( event, itemKey, 'allowedBonusScrollNumber' )}
                    >
                        <ul className="list list--double">{listItems}</ul>
                    </div>
                );

            }

        }

        if ( this.state.buttonDisabled ) {
            listItems = <Loading withBox={true} />;
        }

        if ( this.state.redemptionHistory !== '' && this.state.redemptionHistory.status === 'ERROR' ) {
            listItems = <p className="error-message">{this.state.redemptionHistory.message}</p>;
        }

        return {detailsClass, listItems};

    }

    bonusList(){

        return (
            <div className="main-wrapper__double-list-item ver-top-box">

                <section className={`main-wrapper__services main-wrapper__services--bonus${this.expendedPoints()['detailsClass']}`}>
                    <h2 className="main-wrapper__sub-title main-wrapper__sub-title--bonus monserrat-medium pr sprite-b">{trans( this.props.b2bTrans, 'b2b.bonus.tab.title' )}</h2>
                    <Tab items={[{
                        title: trans( this.props.b2bTrans, 'b2b.bonus.tab.sub_title1' ),
                        content: this.accumulatedPoints()
                    },{
                        title: trans( this.props.b2bTrans, 'b2b.bonus.tab.sub_title2' ),
                        content: this.expendedPoints()['listItems']
                    }]}
                    />
                </section>

            </div>
        );

    }

    render(){

        return(
            <>
                <BackBtn
                    clickCallBack={() => this.props.updateParentState({ detalizationView: false })}
                    title={trans( this.props.b2bTrans, 'b2b.detalization.back_to_title' )}
                />

                {this.filterSection()}

                <div className="main-wrapper__tools clear-fix">
                    <div className="main-wrapper__inner-left fl">{this.expensesList()}</div>
                    <div className="main-wrapper__inner-big">
                        {this.expensesFiltersList()}
                        <div className="main-wrapper__double-list">
                            {this.topupsList()}
                            {this.bonusList()}
                        </div>
                    </div>
                    {this.emailModal()}
                    {this.emailSuccessModal()}
                    {this.errorModal()}
                </div>
                
            </>
        );

    }

}

export default B2bHistory;